import * as React from 'react';
import { useStores } from 'utility/hooks';
import { observer } from 'mobx-react';

import { CustomerNotifications } from 'components/shared';
import { NotificationLocation } from '__generated__/api/types';

export const SearchHeading = observer(() => {
  const { pageTitleStore } = useStores();
  const { loading } = pageTitleStore;

  return (
    <section data-test-id="search-heading">
      {!loading && <CustomerNotifications location={NotificationLocation.AFTER_HEADER} classes="all-b-margin-six" />}
    </section>
  );
});
